<template>
  <div class="car">
      <a @click="toCar">
          <img src="../assets/img/carimg.png" alt="">
          <span>{{count}}</span>
      </a>
  </div>
</template>

<script>
export default {
    prop:['count'],
  data() {
    return {
        count: 0
  }
  
},
methods:{
    async Getcarcount() {
        const res = await this.$http.get('/api/user/count')
        this.count = res.data.shoppingCount
    },
    toCar: function(){
        window.location.href = "/mall/car.html"
    }
},
created(){
    this.Getcarcount()
},
computed: {
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.car{
    position: fixed;
    right: 25px;
    top: 50%;
}
.car a{
    cursor: pointer;
    position: relative;
    display: block;
    width:38px;
    height:38px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 4px 0px rgba(156,156,156,0.5),1px -1px 6px 0px rgba(197,197,197,0.5);
    display: flex;
    justify-content: center;
    align-items: center;

}
.car a img{
    width: 28px;
    height: 28px;
}
.car a span{
    position: absolute;
    display: block;
    top: -9px;
    right: -10px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #cc4a49;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/carshop.vue